import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './Dropdown.module.scss';

const Dropdown = (props) => {
    const navigate = useNavigate();

    const [subTab, setSubTab] = useState(props.subTab);
    const handleChangeSubTab = (item, index) => {
        setSubTab(index);
        navigate(item.path);
    };
    return (
        <>
            {props.items?.length ? (
                <ul className={classes.wrapper}>
                    {props.items.map((item, index) => {
                        return (
                            <li
                                key={item.id}
                                className={
                                    subTab === index && props.tab === props.stayTab
                                        ? classes.item_selected
                                        : classes.item
                                }
                            >
                                <div onClick={() => handleChangeSubTab(item, index)}>{item.text}</div>
                            </li>
                        );
                    })}
                </ul>
            ) : null}
        </>
    );
};

export default Dropdown;
